<script>
export default {
  name: "multi-vessel-offers",
  components: {},
  data: function() {
    return {};
  },
  methods: {
    addCommas: function(x) {
      if (isNaN(x)) {
        return 0;
      }
      var parts = x.toString().split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return parts.join(".");
    },
    averageVesselCost(offer) {
      return (
        offer.vessels
          .map(function(x) {
            return x.rate;
          })
          .reduce(function(a, b) {
            return a + b;
          }, 0) / offer.vessels.length
      );
    },
  },
  computed: {
    multiVesselOffers: function() {
      var self = this;
      return self.$store.state.activeAuction.multiVesselOffers.sort(function(objA, objB) {
        var averagePerVesselA = self.averageVesselCost(objA);
        var averagePerVesselB = self.averageVesselCost(objB);
        return averagePerVesselA - averagePerVesselB;
      });
    },
    activeBid: function() {
      return this.$store.state.activeBid || null;
    },
    currency: function() {
      return this.$store.state.activeAuction.currency;
    },
    isSmallScreen() {
      return this.$store.state.isSmallScreen;
    },
  },

  watch: {
    multiVesselOffers(val, oldVal) {
      if (val > oldVal) {
        this.$emit("newMVO");
      }
    },
  },
};
</script>
<template>
  <div class="content-bordered vessel-list-wrapper">
    <div v-for="(item, index) in multiVesselOffers" :key="`row-mvo-${index}`" class="vessel-panel mult-vessel-offer-wrapper">
      <div
        v-html="
          `${item.vessels
            .map(function(x) {
              if (activeBid && x.offerId == activeBid.offerId) {
                return `<span class='vessel-name' style='font-weight:bold'>${x.vesselName}</span> at <span class='rate'>${addCommas(x.rate)} ${currency}</span>`;
              } else {
                return `<span class='vessel-name'>${x.vesselName}</span> at <span class='rate'>${addCommas(x.rate)} ${currency}</span>`;
              }
            })
            .join('<br/>')} <br/><span style='font-weight:bold;font-size: ${isSmallScreen ? '12px' : '16px'}'>Total for ${item.vessels.length} vessels: <span class='rate'>${addCommas(
            item.vessels
              .map(function(x) {
                return x.rate;
              })
              .reduce(function(a, b) {
                return a + b;
              }, 0)
          )} ${currency}</span></span>`
        "
      ></div>
    </div>
  </div>
</template>
<style scoped>
.vessel-panel {
  -webkit-box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.1);
}

.flip-list-move {
  transition: transform 0.5s;
}
.mult-vessel-offer-wrapper {
  padding: 0.5rem;
}

.vessel-panel:first-child img {
  border-top-left-radius: 10px;
}

.vessel-panel:last-child img {
  border-bottom-left-radius: 10px;
}

.vessel-panel :first-child {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.vessel-panel:last-child {
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}
</style>
